import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Creators } from './duck/actions';

import adTissot from '../../assets/images/ad-tissot.png';
import adSuggested from '../../assets/images/ad-suggested.png';
import adSeparator from '../../assets/images/ad-separator.png';
// import adShop from '../../assets/images/ad-shop.png';

import Banner from '../common/Banner/Banner';
import AdBanner from '../common/AdBanner/AdBanner';

import LatestReviews from '../common/ListWithImage/List_Show_More';
import OuterBox from '../common/OuterBox/OuterBox';
import InnerBox from '../common/InnerBox/InnerBox';

import adAmazon from '../../assets/images/ad-amazon.png';

import { ListElement, Image, FlexContainer } from '../common/StyledComponents';
import { SideBar } from '../common/StyledComponents/StyledSideBar';
import List_XS_Image from '../common/ListWithImage/List_XS_Image';
import List_S_Image from '../common/ListWithImage/List_S_Image';
// import List_M_Image from '../common/ListWithImage/List_M_Image';

class ReviewsSubCategory extends Component {
  // state = {
  //   category: null,
  //   contentData: null
  // };

  componentWillMount = () => {
    // console.log('[reviewsSubCategory.js] componentWillMount');
    window.scrollTo(0, 0);
  };

  componentDidMount = () => {
    let category = this.props.history.location.pathname.slice(9);
    // this.setState({ category: this.props.history.location.pathname.slice(9) });

    // Fetch Reviews Banner depending upon the Review sub-category
    this.props.onFetchReviewsBanner();

    // Top Review remain same
    this.props.onFetchTopReviews();

    // Fetch Laptops Reviews Data
    if (category === 'laptops') {
      this.props.onFetchLaptopsReviews(1);
      if (this.props.bestOfLaptops === null) {
        this.props.onFetchBestOfLaptops();
      }
    }

    // Fetch Mobiles Reviews Data
    if (category === 'mobiles') {
      this.props.onFetchMobilesReviews(1);
      if (this.props.bestOfMobiles === null) {
        this.props.onFetchBestOfMobiles();
      }
    }

    // Fetch Cameras Reviews Data
    if (category === 'cameras') {
      this.props.onFetchCamerasReviews(1);
      if (this.props.bestOfCameras === null) {
        this.props.onFetchBestOfCameras();
      }
    }

    // Fetch Accessories Reviews Data
    if (category === 'accessories') {
      this.props.onFetchAccessoriesReviews(1);
      if (this.props.bestOfAccessories === null) {
        this.props.onFetchBestOfAccessories();
      }
    }
  };

  handleLoadMore = () => {
    let category = this.props.history.location.pathname.slice(9);
    // this.props.onFetchLatestReviews(this.props.pageForLatestReviews);

    // Fetch Laptops Reviews Data
    if (category === 'laptops') {
      this.props.onFetchLaptopsReviews(this.props.pageForLaptopsReviews);
      if (this.props.bestOfLaptops === null) {
        this.props.onFetchBestOfLaptops();
      }
    }

    // Fetch Mobiles Reviews Data
    if (category === 'mobiles') {
      this.props.onFetchMobilesReviews(this.props.pageForMobilesReviews);
      if (this.props.bestOfMobiles === null) {
        this.props.onFetchBestOfMobiles();
      }
    }

    // Fetch Cameras Reviews Data
    if (category === 'cameras') {
      this.props.onFetchCamerasReviews(this.props.pageForCamerasReviews);
      if (this.props.bestOfCameras === null) {
        this.props.onFetchBestOfCameras();
      }
    }

    // Fetch Accessories Reviews Data
    if (category === 'accessories') {
      this.props.onFetchAccessoriesReviews(
        this.props.pageForAccessoriesReviews
      );
      if (this.props.bestOfAccessories === null) {
        this.props.onFetchBestOfAccessories();
      }
    }
  };

  navigate = postSlug => {
    // console.log('postSlug: ', postSlug);
    this.props.history.push(`/${postSlug}`);
  };

  render() {
    let contentData, bestOfContentData;
    let category = this.props.history.location.pathname.slice(9);
    switch (category) {
      case 'laptops':
        contentData = this.props.laptopsReviews;
        bestOfContentData = this.props.bestOfLaptops;
        break;
      case 'mobiles':
        contentData = this.props.mobilesReviews;
        bestOfContentData = this.props.bestOfMobiles;
        break;
      case 'cameras':
        contentData = this.props.camerasReviews;
        bestOfContentData = this.props.bestOfCameras;
        break;
      case 'accessories':
        contentData = this.props.accessoriesReviews;
        bestOfContentData = this.props.bestOfAccessories;
        break;
      default:
        break;
    }

    return (
      <div className="Reviews">
        <AdBanner height="250px" width="970px" margin="18px 0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        {this.props.reviewsBannerData ? (
          <Banner
            bannerData={this.props.reviewsBannerData}
            clicked={this.navigate}
          />
        ) : null}

        <FlexContainer className="mv3 mh2 justify-center">
          <AdBanner height="91px" width="730px">
            <Image
              src={adSeparator}
              width="100%"
              height="100%"
              alt="tissot ad"
            />
          </AdBanner>
        </FlexContainer>

        <OuterBox>
          <InnerBox>
            <LatestReviews
              title={`${category} Reviews`}
              contentData={contentData}
              handleLoadMore={this.handleLoadMore}
              clicked={this.navigate}
              showMore="true"
            />

            <SideBar>
              <AdBanner height="250px" width="300px" margin="0 0 1rem 0">
                <Image
                  src={adAmazon}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
              {bestOfContentData ? (
                // eslint-disable-next-line
                <List_XS_Image
                  className="List_XS_Image mb3"
                  title="Best of Laptops"
                  listItems={bestOfContentData}
                />
              ) : null}

              {this.props.topReviews ? (
                // eslint-disable-next-line
                <List_S_Image
                  title="Top Reviews"
                  listItems={this.props.topReviews}
                />
              ) : null}
            </SideBar>
          </InnerBox>
        </OuterBox>

        <FlexContainer className="justify-center">
          <AdBanner height="91px" width="730px">
            <Image
              src={adSeparator}
              width="100%"
              height="100%"
              alt="tissot ad"
            />
          </AdBanner>
        </FlexContainer>

        <OuterBox>
          <InnerBox>
            <ListElement className="w-100" maxwidth="100%" padding="20px">
              {/* <Title
                fontFamily="Montserrat"
                fontSize="1.5rem"
                fontWeight="bold"
              >
                Suggested
              </Title>
              <StyledLine>
                <StyledLineInside />
              </StyledLine> */}
              {/* <AdBanner height="210px" width="1000px" margin="0"> */}
              <AdBanner height="346px" width="1040px" margin="0">
                <Image
                  src={adSuggested}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </ListElement>
          </InnerBox>
        </OuterBox>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log('state: ', state);
  return {
    loading: state.reviews.loading,
    reviewsBannerData: state.reviews.reviewsBannerData,
    pageForLaptopsReviews: state.reviews.pageForLaptopsReviews,
    pageForMobilesReviews: state.reviews.pageForMobilesReviews,
    pageForCamerasReviews: state.reviews.pageForCamerasReviews,
    pageForAccessoriesReviews: state.reviews.pageForAccessoriesReviews,
    topReviews: state.reviews.topReviews,
    laptopsReviews: state.reviews.laptopsReviews,
    mobilesReviews: state.reviews.mobilesReviews,
    camerasReviews: state.reviews.camerasReviews,
    accessoriesReviews: state.reviews.accessoriesReviews,
    bestOfLaptops: state.reviews.bestOfLaptops,
    bestOfMobiles: state.reviews.bestOfMobiles,
    bestOfCameras: state.reviews.bestOfCameras,
    bestOfAccessories: state.reviews.bestOfAccessories
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchReviewsBanner: () => dispatch(Creators.fetchReviewsBanner()),
  onFetchTopReviews: () => dispatch(Creators.fetchTopReviews()),
  onFetchLaptopsReviews: page => dispatch(Creators.fetchLaptopsReviews(page)),
  onFetchMobilesReviews: page => dispatch(Creators.fetchMobilesReviews(page)),
  onFetchCamerasReviews: page => dispatch(Creators.fetchCamerasReviews(page)),
  onFetchAccessoriesReviews: page =>
    dispatch(Creators.fetchAccessoriesReviews(page)),
  onFetchBestOfLaptops: () => dispatch(Creators.fetchBestOfLaptops()),
  onFetchBestOfMobiles: () => dispatch(Creators.fetchBestOfMobiles()),
  onFetchBestOfCameras: () => dispatch(Creators.fetchBestOfCameras()),
  onFetchBestOfAccessories: () => dispatch(Creators.fetchBestOfAccessories())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReviewsSubCategory);
